import API from "./api";

export async function storeTrack(id: string): Promise<void> {
    return API.post(`/api/tracks/${id}/store`).then(() => {
        return Promise.resolve();
    }).catch(error => {
        return Promise.reject(error);
    });

};